export default {
  app: {
    loaded: false,
    loading: false
  },
  countries: [],
  translations: []
};
